import { render, staticRenderFns } from "./TeamItems.vue?vue&type=template&id=138781a4&scoped=true&"
var script = {}
import style0 from "./TeamItems.vue?vue&type=style&index=0&id=138781a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138781a4",
  null
  
)

component.options.__file = "TeamItems.vue"
export default component.exports